// Must stay the FIRST import: it wraps axios/fetch before any module creates an
// instance, so hub calls carry a server-issued session (src/Util/hubSession.js).
import './Util/hubSession';
// SHUB-FE's admin-login rule for hub sessions (every logged-in user is staff). Keep second.
import './Util/hubSessionConfig';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
require('react-web-vector-icons/fonts');


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	</React.StrictMode>
);
